import React, { Component } from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  RedditShareButton,
  EmailShareButton
} from 'react-share';
import PropTypes from 'prop-types';
import Icon from '../Icon';

class ShareButtons extends Component {
  render() {
    const { url, title, media } = this.props;

    return (
      <div className={'ShareButtons'}>
        <FacebookShareButton url={url} quote={title}>
          <Icon name="facebook" />
        </FacebookShareButton>

        <TwitterShareButton url={url} title={title}>
          <Icon name="twitter" />
        </TwitterShareButton>

        <WhatsappShareButton url={url} title={title} separator=":: ">
          <Icon name="whatsapp" />
        </WhatsappShareButton>
        {media && (
          <PinterestShareButton
            url={url}
            media={media}
            windowWidth={1000}
            windowHeight={730}
          >
            <Icon name="pinterest" />
          </PinterestShareButton>
        )}
        <RedditShareButton
          url={url}
          title={title}
          windowWidth={660}
          windowHeight={460}
        >
          <Icon name="reddit" />
        </RedditShareButton>

        <EmailShareButton url={url} subject={title}>
          <Icon name="envelope" />
        </EmailShareButton>
        <div
          className="SocialMediaShareButton SocialMediaShareButton--print"
          tabIndex="0"
          onClick={() => window.print()}
        >
          <Icon name="print" />
        </div>
      </div>
    );
  }
}

ShareButtons.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  media: PropTypes.string
};

export default ShareButtons;



// WEBPACK FOOTER //
// ./src/components/common/ShareButtons/index.jsx